export default __webpack_public_path__ + "static/media/Fexocon-120-eng.be62d2ba.jpg";